<template>
  <div>
    <el-row :gutter="10" class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="10" :md="10">
        <el-input v-model="filtro.nome" placeholder="Pesquisar por nome ou sigla" @keyup.native.enter="load"></el-input>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <el-select v-model="filtro.grandeza" placeholder="Grandeza" clearable @change="load" style="width:100%">
          <el-option label="MASSA" value="massa"></el-option>
          <el-option label="VOLUME" value="volume"></el-option>
          <el-option label="CONTAGEM" value="contagem"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
        <el-button class="u-mr-10" @click="dialogConversao = true" type="warning" plain icon="el-icon-sort">CONVERTER</el-button>
        <router-link to="/admin/merenda/unidade-medida/cadastro" class="btn-new-register" v-if="podeEscrever">
          <el-button type="primary">NOVA UNIDADE</el-button>
        </router-link>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th>Nome</th>
            <th style="width: 90px;">Sigla</th>
            <th class="hidden-mobile" style="width: 120px;">Grandeza</th>
            <th class="hidden-mobile u-text-right" style="width: 170px;">Fator (na base)</th>
            <th class="hidden-mobile u-text-center" style="width: 80px;">Base</th>
            <th class="hidden-mobile u-text-center" style="width: 80px;">Ativa</th>
            <th style="width: 140px;" class="u-text-center" v-if="podeEscrever">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ item.nome }}</td>
            <td><strong>{{ item.sigla }}</strong></td>
            <td class="hidden-mobile">{{ item.grandeza.toUpperCase() }}</td>
            <td class="hidden-mobile u-text-right">
              {{ item.fator_base }} {{ baseDa(item.grandeza) }}
            </td>
            <td class="hidden-mobile u-text-center">{{ item.base ? 'SIM' : '—' }}</td>
            <td class="hidden-mobile u-text-center">{{ item.situacao ? 'SIM' : 'NÃO' }}</td>
            <td class="u-text-center acao" v-if="podeEscrever">
              <router-link :to="'/admin/merenda/unidade-medida/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
              </router-link>
              <el-button @click="deleteItem(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
          <tr v-if="items.length === 0">
            <td :colspan="podeEscrever ? 8 : 7" class="u-text-center">Nenhuma unidade encontrada.</td>
          </tr>
        </tbody>
      </table>

      <el-row v-if="statusList">
        <el-col :xs="24" :sm="12" :md="12">
          <div class="u-mt-10">
            <small v-if="paginate.qtdItens">Exibindo {{ paginate.from }} a {{ paginate.to }} de {{ paginate.qtdItens }}</small>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 15">
          <div class="u-text-right">
            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
              @current-change="getPagePagination" :page-size="15" background layout="prev, pager, next" small></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog title="Converter unidade de medida" :visible.sync="dialogConversao" width="520px">
      <el-row :gutter="10">
        <el-col :span="8">
          <label class="u-fs-12">Valor</label>
          <el-input v-model="conversao.valor" type="number"></el-input>
        </el-col>
        <el-col :span="8">
          <label class="u-fs-12">De</label>
          <el-select v-model="conversao.de" filterable placeholder="Origem" style="width:100%">
            <el-option v-for="u in todas" :key="'de'+u.id" :label="u.sigla + ' — ' + u.nome" :value="u.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <label class="u-fs-12">Para</label>
          <el-select v-model="conversao.para" filterable placeholder="Destino" style="width:100%">
            <el-option v-for="u in todas" :key="'para'+u.id" :label="u.sigla + ' — ' + u.nome" :value="u.id"></el-option>
          </el-select>
        </el-col>
      </el-row>

      <div class="u-mt-20" v-if="resultado">
        <el-alert v-if="resultado.erro" :title="resultado.erro" type="warning" :closable="false" show-icon></el-alert>
        <el-alert v-else
          :title="`${resultado.valor_origem} ${resultado.unidade_origem} = ${resultado.valor_convertido} ${resultado.unidade_destino}`"
          type="success" :closable="false" show-icon></el-alert>
      </div>

      <span slot="footer">
        <el-button @click="dialogConversao = false">FECHAR</el-button>
        <el-button class="u-ml-10" type="primary" @click="converter" :disabled="!conversao.valor || !conversao.de || !conversao.para">CONVERTER</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtro: { nome: '', grandeza: '' },
    paginate: { page: 1, qtdItens: null, from: '', to: '' },
    items: [],
    todas: [],
    dialogConversao: false,
    conversao: { valor: '', de: '', para: '' },
    resultado: null
  }),
  computed: {
    // Catálogo de rede: só NTI mantém. A tela apenas reflete a matriz do backend,
    // que é quem decide de fato — a regra não vive aqui.
    podeEscrever () {
      return [4, 5, 6].indexOf(Number(this.$store.state.user.tipo)) !== -1
    }
  },
  mounted () { this.load(); this.carregarTodas() },
  methods: {
    baseDa (grandeza) {
      return { massa: 'g', volume: 'ml', contagem: 'un' }[grandeza] || ''
    },
    load () {
      this.statusList = false
      this.items = []
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/unidade-medida/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.items = response.data.data
          this.paginate.qtdItens = response.data.total
          this.paginate.from = response.data.from
          this.paginate.to = response.data.to
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    carregarTodas () {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/unidade-medida/getAll`, this.$store.getters.getHeaderAuth)
        .then(response => { this.todas = response.data })
        .catch(() => { this.todas = [] })
    },
    converter () {
      this.resultado = null
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/unidade-medida/converter`, this.conversao, this.$store.getters.getHeaderAuth)
        .then(response => { this.resultado = response.data })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    deleteItem (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir esta unidade?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/unidade-medida/delete/` + id, this.$store.getters.getHeaderAuth)
            .then(response => {
              window.eventBus.$emit('loading', false)
              if (response.data && response.data.erro) {
                return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
              }
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    getPagePagination (page) {
      this.paginate.page = page
      this.load()
    }
  }
}
</script>
